jQuery_3_3_1(document).ready(function($) {
  /*
  var lineasDeTiempo = [{ el: "#lineasDeTiempo", v: null, init: false }];
  var mapasACartogamas = [{ el: "#mapaACartograma", v: null, init: false }];
  var mapasABarras = [{ el: "#mapaABarras", v: null, init: false }];
  var nubesDePalabras = [{ el: "#nubeDePalabras", v: null, init: false }];
  var lineasDeTiempoSelector = [
    { el: "#lineasDeTiempoSelector", v: null, init: false }
  ];
  */
  var lineasDeTiempo = [];
  var mapasACartogamas = [];
  var mapasABarras = [];
  var nubesDePalabras = [];
  var lineasDeTiempoSelector = [];

  var arreglo = $("[data-tipo-visualizacion=lineasDeTiempo]");
  _.each(arreglo, function(e) {
    lineasDeTiempo.push({ el: e, v: null, init: false });
  });

  arreglo = $("[data-tipo-visualizacion=mapaACartograma]");
  _.each(arreglo, function(e) {
    mapasACartogamas.push({ el: e, v: null, init: false });
  });

  arreglo = $("[data-tipo-visualizacion=mapaABarras]");
  _.each(arreglo, function(e) {
    mapasABarras.push({ el: e, v: null, init: false });
  });

  arreglo = $("[data-tipo-visualizacion=nubeDePalabras]");
  _.each(arreglo, function(e) {
    nubesDePalabras.push({ el: e, v: null, init: false });
  });

  arreglo = $("[data-tipo-visualizacion=lineasDeTiempoSelector]");
  _.each(arreglo, function(e) {
    lineasDeTiempoSelector.push({ el: e, v: null, init: false });
  });

  _.each(lineasDeTiempo, function(l) {
    if ($(l.el).visible()) {
      if (l.init === false) {
        l.init = true;
        l.v = new LineaDeTiempo($, l.el, true);
        /*
        $(l.el)
          .closest("section")
          .find("img[alt=download]")
          .closest("a")
          .attr("href", "#")
          .click(function(event) {
            event.preventDefault();
            event.stopPropagation();
            l.v.descargar();
          });
          */
      }
    } else {
      l.v = new LineaDeTiempo($, l.el);
      $(window).scroll(function() {
        if ($(l.el).visible()) {
          if (l.init === false) {
            l.init = true;
            l.v.iniciar();
            /*
            $(l.el)
              .closest("section")
              .find("img[alt=download]")
              .closest("a")
              .attr("href", "#")
              .click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                l.v.descargar();
              });
              */
          }
        }
      });
    }
  });

  _.each(mapasACartogamas, function(m) {
    if ($(m.el).visible()) {
      if (m.init === false) {
        m.init = true;
        m.v = new MapaACartograma($, m.el, true);
      }
    } else {
      m.v = new MapaACartograma($, m.el);
      $(window).scroll(function() {
        if ($(m.el).visible()) {
          if (m.init === false) {
            m.init = true;
            m.v.iniciar();
          }
        }
      });
    }
  });

  _.each(mapasABarras, function(m) {
    if ($(m.el).visible()) {
      if (m.init === false) {
        m.init = true;
        m.v = new MapaABarras($, m.el, true);
      }
    } else {
      m.v = new MapaABarras($, m.el);
      $(window).scroll(function() {
        if ($(m.el).visible()) {
          if (m.init === false) {
            m.init = true;
            m.v.iniciar();
          }
        }
      });
    }
  });

  _.each(nubesDePalabras, function(n) {
    if ($(n.el).visible()) {
      if (n.init === false) {
        n.init = true;
        n.v = new NubeDePalabras($, n.el, true);
      }
    } else {
      n.v = new NubeDePalabras($, n.el);
      $(window).scroll(function() {
        if ($(n.el).visible()) {
          if (n.init === false) {
            n.init = true;
            n.v.iniciar();
          }
        }
      });
    }
  });

  _.each(lineasDeTiempoSelector, function(l) {
    if ($(l.el).visible()) {
      if (l.init === false) {
        l.init = true;
        l.v = new LineaDeTiempoSelector($, l.el, true);
      }
    } else {
      l.v = new LineaDeTiempoSelector($, l.el);
      $(window).scroll(function() {
        if ($(l.el).visible()) {
          if (l.init === false) {
            l.init = true;
            l.v.iniciar();
          }
        }
      });
    }
  });
});
